module.exports = __webpack_public_path__ + "static/N2N3s-95f5a50c109d3b154026f27c3bb3efcf.jpg";